var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Mauritania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M39.18,37H8.82c3.668,4.279,9.102,7,15.18,7S35.512,41.279,39.18,37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M24,4c-6.078,0-11.512,2.721-15.18,7h30.36C35.512,6.721,30.078,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b5e20",
    d: "M44,24c0-4.968-1.822-9.503-4.82-13H8.82C5.822,14.497,4,19.032,4,24c0,4.968,1.822,9.503,4.82,13 h30.36C42.178,33.503,44,28.968,44,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc400",
    d: "M24,15.094L23.055,18H20l2.473,1.797l-0.945,2.906L24,20.906l2.473,1.797l-0.945-2.906L28,18h-3.055 L24,15.094z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc400",
    d: "M33.703,19c-0.023,5.156-4.527,9-9.688,9c-0.004,0-0.012,0-0.016,0c-0.008,0-0.012,0-0.016,0 c-5.16,0-9.664-3.844-9.688-9C14.094,19.785,14,20.465,14,21.309C14,26.66,18.645,31,24,31s10-4.34,10-9.691 C34,20.465,33.906,19.785,33.703,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mauritania);
export default __webpack_public_path__ + "static/media/icons8-mauritania.df8cffbb36be51d01d2c63edae66a02d.svg";
export { ForwardRef as ReactComponent };